<template>
    <div class="section">
        <div class="section__container">
            <div class="section__right">
                <div class="section__form">
                    <div class="section__header">Create Password</div>
                    <div class="section__caption">Please enter your new password.</div>
                    <form @submit.prevent="resetPassword">
                        <div class="form__item">
                            <label class="form__label" for>Password</label>
                            <input class="form__input" type="password" v-model="password.value" />
                            <span class="attention" v-if="password.empty">Field can't be empty</span>
                        </div>
                        <br />
                        <button class="btn btn--primary btn--block" type="submit">Submit</button>
                    </form>
                    <div class="form__footer">
                        <p>
                            <router-link to="/login">Go back to sign in</router-link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: "Complete Reset"
    },
    data() {
        return {
            password: {
                value: "",
                empty: false
            },
            disabled: false
        };
    },

    created() {
        window.localStorage.clear();
    },

    methods: {
        resetPassword() {
            this.password.empty = false;
            if (this.password.value !== "") {
                this.disabled = true;
                let requestObject = {
                    new_password: this.password.value.trim(),
                    token: this.$route.query.token
                };
                this.$http
                    .post("dashboard/merchants/password_reset_complete", requestObject)
                    .then(response => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "success text-white",
                            title: "Success",
                            text: response.body.message
                        });
                        this.$router.push({ name: "login" });
                    })
                    .catch(error => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "error text-white",
                            title: "Error",
                            text: error.body.message
                        });
                    });
            } else {
                this.password.empty = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.section {
    background-image: url("../../../public/img/background.svg");
    background-repeat: no-repeat;
    background-position: right center;
    background-size: contain;
    height: 100vh;
    display: flex;
    align-items: center;
    &__container {
        @include container;
        display: flex;
        justify-content: center;
    }

    &__right {
        width: 448px;
        background-color: #ffffff;
        border: 1px solid rgba(97, 110, 124, 0.2);
        box-sizing: border-box;
        box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        padding: 40px 64px 0;
    }

    &__left {
        width: 50%;
        margin-right: 168px;
    }

    &__header {
        font-size: 32px;
        margin-bottom: 22px;
        font-weight: 400;
    }

    &__caption {
        font-size: 14px;
        line-height: 24px;
        color: #261940;
        margin-bottom: 22px;
    }
}
</style>